

























































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import PlusIcon from 'mdi-vue/Plus';
import ExportIcon from 'mdi-vue/FileExportOutline';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import DatePicker from '@/components/DatePicker.vue';
import Modal from '@/components/Modal.vue';
import Select2 from '@/components/Select2.vue';
import Loader from '@/components/Loader.vue';
import FormInput from '@/components/FormInput.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Toggle from '@/components/Toggle.vue';
import CloseIcon from 'mdi-vue/Close';
import SearchIcon from 'mdi-vue/Magnify';

import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import api from '@/libs/api';
import { PricingPartnerDetail, PartnerBank } from '@/libs/api.interfaces';

import ReportTable from './PricingTable.vue';
import BalanceJumbotron from './components/BalanceJumbotron.vue';

// extend('greater', {
//   params: ['target'],
//   validate(value, { target }) {
//     let vInt = 0;
//     let tarInt = 0;
//     try {
//       vInt = parseInt(value, 10);
//       tarInt = parseInt(target, 10);
//     } catch (err) {
//       console.error(err);
//     }
//     if (vInt <= tarInt) {
//       return false;
//     }
//     return true;
//   },
//   message: 'Maximum amount must be great than minimum amount',
// });

interface Tier {
  min: string;
  max: string;
  price: string;
}

interface LabelValue {
  id: string;
  label: string;
  value: string;
}

@Component({
  components: {
    LayoutTitle,
    Button,
    LayoutContent,
    BalanceJumbotron,
    ReportTable,
    PlusIcon,
    ExportIcon,
    SearchRow,
    SearchField,
    DatePicker,
    Select,
    FormInput,
    Modal,
    Select2,
    ValidationObserver,
    Loader,
    Toggle,
    CloseIcon,
    SearchIcon,
  },
})

export default class Pricing extends Vue {
  $refs!: {
    report: ReportTable;
  }

  searchOpen = false;
  loadingPopup = false;
  isEditPricing = false;
  loadingExport = false;
  modalAddPricing = false;
  loadingListBank = false;

  listBankFilter = [{ id: '', label: '' }];

  filterBank: any = null;

  listBank: LabelValue[] | null = null;
  selectedBank: LabelValue[] | null = null;

  stts: string | undefined = undefined;
  bankCode: string | undefined = undefined;

  statusPaymentChannel: LabelValue[] = [
    {
      id: '',
      label: 'ACTIVE',
      value: 'ACTIVE',
    },
    {
      id: '',
      label: 'INACTIVE',
      value: 'INACTIVE',
    },
  ];

  selectedStatusPaymentChannel: LabelValue | null = null;

  token = '';
  description = '';
  pricingStatus = true;

  pricingId = 0;

  dataTier: Tier[] = [];

  async mounted() {
    this.token = JSON.parse(localStorage.getItem('USER') || '{}').token;
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getPartnerPricing(page: number) {
    const params = {
      page,
      status: this.stts,
      // eslint-disable-next-line @typescript-eslint/camelcase
      bank_code: this.bankCode,
      export: this.loadingExport,
    };
    return this.$refs.report.getPartnerPricing(params);
  }

  parseParams() {
    const params = this.$route.query;

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    if (typeof params.bank_code === 'string') {
      this.bankCode = params.bank_code;
    }

    if (typeof params.status === 'string') {
      this.stts = params.status;
    }

    this.getPartnerPricing(page);
  }

  async exportPricing() {
    this.loadingExport = true;
    showToast(ToastType.SUCCESS, 'Export Transaction', 'Export is starting, please wait! This may take a while');

    try {
      const path = await this.getPartnerPricing(1);
      this.downloadSheet(path);
      showToast(ToastType.SUCCESS, 'Success', 'Export merchant account state success');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to download sheet');
    }

    this.loadingExport = false;
  }

  async savePricing() {
    try {
      const bank = this.selectedBank?.map((f: LabelValue) => f.id);
      const pricing = this.dataTier.map((item: Tier) => ({
        // eslint-disable-next-line @typescript-eslint/camelcase
        min_amount: item.min,
        // eslint-disable-next-line @typescript-eslint/camelcase
        max_amount: item.max,
        price: item.price,
      }));
      await api.post('/disbursement/pricing/partner', {
        pricing,
        // eslint-disable-next-line @typescript-eslint/camelcase
        id_payment_channel: bank,
        // eslint-disable-next-line @typescript-eslint/camelcase
        partner_id: this.$route.params.id,
        description: this.description,
        status: this.pricingStatus ? 'ACTIVE' : 'INACTIVE',
      });

      this.parseParams();
      this.closeModal();
      showToast(ToastType.SUCCESS, 'Add Pricing Success', 'Successfully add partner\'s pricing');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to add partner\'s pricing');
      console.error(err);
    }
  }

  async updatePricing() {
    try {
      const bank = this.selectedBank?.map((f: LabelValue) => f.id);
      const pricing = this.dataTier.map((item: Tier) => ({
        // eslint-disable-next-line @typescript-eslint/camelcase
        min_amount: item.min,
        // eslint-disable-next-line @typescript-eslint/camelcase
        max_amount: item.max,
        price: item.price,
      }));
      await api.put('/disbursement/pricing/partner', {
        pricing,
        id: this.pricingId,
        // eslint-disable-next-line @typescript-eslint/camelcase
        id_payment_channel: bank,
        // eslint-disable-next-line @typescript-eslint/camelcase
        partner_id: this.$route.params.id,
        description: this.description,
        status: this.pricingStatus ? 'ACTIVE' : 'INACTIVE',
      });

      this.parseParams();
      this.closeModal();
      showToast(ToastType.SUCCESS, 'Edit Pricing Success', 'Successfully edit partner\'s pricing');
    } catch (err) {
      showToast(ToastType.FAILED, 'Oops… Sorry', 'Failed to edit partner\'s pricing');
      console.error(err);
    }
  }

  async toggleSearchOpen() {
    try {
      const { data } = await api.get<{ id: number; code: string; name: string }[]>('/disbursement/bank/partner');
      // eslint-disable-next-line max-len
      this.listBankFilter = data.map((e: { id: number; code: string; name: string }) => ({ id: e.id.toString(), label: e.name, code: e.code }));
    } catch (err) {
      console.error(err);
    }
    this.searchOpen = !this.searchOpen;
  }

  async toggleAddPricing() {
    this.dataTier = [
      {
        min: '',
        max: '',
        price: '',
      },
    ];
    this.loadingListBank = true;
    this.setPartnerBank();
    this.loadingListBank = false;
    this.loadingPopup = true;
    this.isEditPricing = false;
    this.modalAddPricing = !this.modalAddPricing;
  }

  async toggleEditPricing(id: number) {
    this.pricingId = id;
    this.isEditPricing = true;
    try {
      await this.setPartnerBank();
      const { data } = await api.get<PricingPartnerDetail>('/disbursement/pricing/partner', {
        params: {
          id,
          // eslint-disable-next-line @typescript-eslint/camelcase
          partner_id: this.$route.params.id,
        },
      });

      this.dataTier = data.pricing.map((item: {
        min_amount: string;
        max_amount: string;
        price: string;
      }) => ({ min: item.min_amount, max: item.max_amount, price: item.price }));

      this.selectedBank = [
        {
          id: data.bank.code,
          label: data.bank.name,
          value: '',
        },
      ];

      this.description = data.description;
      this.pricingStatus = data.status === 'ACTIVE';

      this.loadingPopup = true;
      this.modalAddPricing = !this.modalAddPricing;

      return null;
    } catch (err) {
      console.error(err);

      throw err;
    }
  }

  async setPartnerBank() {
    try {
      const { data } = await api.get<PartnerBank[]>('/disbursement/bank/partner', {
        params: {
          // eslint-disable-next-line @typescript-eslint/camelcase
          partner_id: this.$route.params.id,
        },
      });

      this.listBank = data.map((item: PartnerBank) => ({ id: item.code, label: item.name })) as LabelValue[];
    } catch (err) {
      console.error(err);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(path: string | null) {
    const fileLink = document.createElement('a');
    fileLink.href = `${process.env.VUE_APP_API_URL}${path}`;
    fileLink.setAttribute('download', 'report.xlsx');

    document.body.appendChild(fileLink);
    fileLink.click();
  }

  addTier() {
    this.dataTier.push({
      min: '',
      max: '',
      price: '',
    });
  }

  deleteTier(index: number) {
    const current = this.dataTier.slice();
    current.splice(index, 1);
    this.dataTier = current;
  }

  closeModal() {
    this.dataTier = [];
    this.selectedBank = null;
    this.loadingPopup = false;
    this.isEditPricing = false;
    this.loadingListBank = false;
    this.description = '';
    this.pricingStatus = true;
    this.modalAddPricing = !this.modalAddPricing;
  }

  cancel() {
    this.$router.push({
      query: {},
    });
  }

  search() {
    this.$router.push({
      query: {
        // eslint-disable-next-line @typescript-eslint/camelcase
        bank_code: this.filterBank?.code,
        status: this.selectedStatusPaymentChannel?.value,
      },
    });
  }
}
